import { useState, useEffect } from 'react';
import { getUserTimeFormat } from '../utils/dateUtility';

/**
 * Custom hook to manage user's time format preference.
 * Detects format on mount and provides consistent access throughout the app.
 *
 * @returns {Object} - { timeFormat: '12h' | '24h', is12Hour: boolean }
 */
export const useTimeFormat = () => {
  const [timeFormat, setTimeFormat] = useState(() => getUserTimeFormat());

  useEffect(() => {
    // Detect format on mount
    const format = getUserTimeFormat();
    setTimeFormat(format);

    // Optional: Listen for locale changes (if browser supports it)
    const handleLocaleChange = () => {
      const newFormat = getUserTimeFormat();
      if (newFormat !== timeFormat) {
        setTimeFormat(newFormat);
      }
    };

    // Some browsers support this event
    window.addEventListener('languagechange', handleLocaleChange);

    return () => {
      window.removeEventListener('languagechange', handleLocaleChange);
    };
  }, [timeFormat]);

  return {
    timeFormat,
    is12Hour: timeFormat === '12h'
  };
};
